/* eslint-disable */
import React, { use, useEffect } from 'react';
/* eslint-disable */
import ReactDOM from 'react-dom';
import './index.css';
// import './clarity';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import Main from './store/Main';
import * as Sentry from "@sentry/react";
import { Provider } from 'react-redux';
import { PersistGate } from "redux-persist/integration/react";
import { persistor, store } from "./redux-store";
import 'bootstrap/dist/css/bootstrap.min.css';
import RestaurantList from './layout-one/js/components/swapHand copy/RestaurantList';

Sentry.init({
  dsn: "https://88498925e9d70c0f8cb2979bb4b2404e@sentry.enabill.dev/32",
  integrations: [
    new Sentry.Integrations.Breadcrumbs({
      console: false,
    }),
  ],
  tracesSampleRate: 1,
});

const appName = process.env.REACT_APP_NAME;
const slugFromEnv = appName !== "null" ? appName : null;
const baseName = slugFromEnv ? `/${appName}` : null;

ReactDOM.render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <I18nextProvider i18n={i18n}>
        {slugFromEnv == null ? (
          <BrowserRouter>
            <Switch>
              <Route exact path="/">
                <RestaurantList />
              </Route>
              <Route path="/:slug">
                <Main />
              </Route>
            </Switch>
          </BrowserRouter>
        ) : (
          <BrowserRouter basename={baseName}>
            <Main />
          </BrowserRouter>
        )}
      </I18nextProvider>
    </PersistGate>
  </Provider>,
  document.getElementById('root')
);

reportWebVitals();
